import { useFetch } from "../../hooks/useFetch";
import { getSkills } from "../../services/firestore";
import { LoadingTerminal } from "../ui/LoadingState";
import "./Skills.css";

const CATEGORY_LABELS = {
  "Languages":             "Languages",
  "Frontend & Backend":    "Frontend & Backend",
  "Data Science & ML":     "Data Science & Machine Learning",
  "Databases & Systems":   "Databases & Systems",
  "Cloud, DevOps & Tools": "Cloud, DevOps & Tools",
};

export default function Skills() {
  const { data, loading, error } = useFetch(getSkills, []);

  const grouped = data || {};

  return (
    <section id="skills" className="section skills">
      <div className="container">
        <h2 className="section-title">
          <span className="section-title__index">01</span>
          Skills
        </h2>

        {loading && (
          <LoadingTerminal
            title="skills.sync"
            lines={[
              { key: "skills-headline", variant: "headline" },
              { key: "skills-meta", variant: "title" },
              { key: "skills-line-1", variant: "text" },
              { key: "skills-line-2", variant: "text", style: { width: "72%" } },
            ]}
            meta={<span>Fetching skills grouped by category.</span>}
          />
        )}
        {error && <p className="skills__error">Error: {error}</p>}

        {!loading && !error && (
          <div className="skills__categories">
            {Object.entries(grouped).map(([cat, skills]) => (
              <div key={cat} className="skills__category">
                <h3 className="skills__cat-title">
                  <span className="skills__cat-marker">//</span>
                  {CATEGORY_LABELS[cat] || cat}
                </h3>
                <ul className="skills__list">
                  {skills.map((s) => (
                    <li key={s.id} className="skill-chip">
                      {s.icon && <span className="skill-chip__icon" aria-hidden="true">{s.icon}</span>}
                      {s.name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
